<template>
  <div class="hero">
    <div class="hero__content">
      <Header class="hero__header" />
      <div class="hero__data">
        <h1>
          <span class="hero__title">Moving from Discord to Slack?</span>
          <span class="hero__subtitle">
            <strong>How to migrate from Discord to Slack</strong>
            <br>
            and take all your karma with you
          </span>
        </h1>
      </div>
    </div>
    <HeroBackground class="hero__background" />
  </div>
</template>

<script>
  import Header from './Header'
  import HeroBackground from './HeroBackground'

  export default {
    components: {
      Header,
      HeroBackground
    },
  }
</script>

<style lang="scss" scoped>
  @import '../assets/styles/utils.sass';

  .hero {
    background: #183E55;
    position: relative;
    padding-bottom: 200px;
  }

  .hero__header {
    position: relative;
    z-index: 2;
  }

  .hero__content {
    position: relative;
    z-index: 3;
  }

  .hero__data {
    padding: 80px 30px 120px;
    text-align: center;
    color: #fff;
  }

  .hero__title {
    font-weight: bold;
    font-size: 50px;
    display: block;
  }

  .hero__subtitle {
    margin-top: 30px;
    line-height: 32px;
    font-size: 25px;
    display: block;
  }

</style>
